import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const error = params.get("error");

    if (error || !code) {
      navigate("/login", { replace: true });
      return;
    }

    const redirect_uri = window.location.origin + "/auth/callback";

    (async () => {
      try {
        const { data } = await api.post("/auth/google/callback", { code, redirect_uri });
        setUser(data);
        // Clean URL and redirect to dashboard
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data } });
      } catch (e) {
        if (e?.response?.status === 403) {
          navigate("/login", { replace: true, state: { accessDenied: true } });
        } else {
          navigate("/login", { replace: true });
        }
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B0E14]">
      <div className="text-orange-400 font-display tracking-widest text-sm uppercase animate-pulse" data-testid="auth-callback-loading">
        Authenticating · Secure handshake
      </div>
    </div>
  );
}
